import React from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { ButtonComponent, type ButtonComponentProps } from './ButtonComponent';

export interface AddButtonProps extends Omit<ButtonComponentProps, 'children' | 'startIcon'> {
  text?: string;
}

export const AddButton: React.FC<AddButtonProps> = ({
  text = "Add New",
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  ...props
}) => {
  return (
    <ButtonComponent
      variant={variant}
      color={color}
      size={size}
      startIcon={<AddIcon />}
      sx={{
        fontFamily: '"DM Sans", sans-serif',
        fontWeight: 600,
        fontSize: '0.85rem',
        textTransform: 'none',
        borderRadius: 2,
        px: 2.5,
        background: 'linear-gradient(135deg, #0f2847 0%, #1a4a6e 100%)',
        color: '#fff',
        boxShadow: '0 2px 8px rgba(15,40,71,0.25)',
        '&:hover': {
          background: 'linear-gradient(135deg, #1a3a5c 0%, #2a5a7e 100%)',
          boxShadow: '0 4px 12px rgba(15,40,71,0.35)',
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
        transition: 'all 0.2s ease',
      }}
      {...props}
    >
      {text}
    </ButtonComponent>
  );
};

export default AddButton;
